import API from '@aws-amplify/api';
import { bookmarkGetAPI,getBookmark } from '@/graphql/queries';
import { bookmarkUpdateAPI } from '@/graphql/mutations';

export const getBookmarkAPI = async (params) => {
    try {
        let res = await API.graphql({
            query: bookmarkGetAPI,
            variables: {
                params: {
                    ...params
                }
            },
        });
        return res.data.bookmarkGetAPI;
    } catch (err) {
        console.log('getBookmarkAPI error >>>', err)
        return [];
    }
};

export const updateBookmarkAPI = async (params) => {
    try {
        let res = await API.graphql({
            query: bookmarkUpdateAPI,
            variables: {
                bookmarkUpdateAPIRequestDto: {
                    ...params
                }
            }
        });

        return res.data.bookmarkUpdateAPI;
    } catch (err) {
        return {};
    }
};

export const getBookmarkById = async (bookmarkId) => {
    try {
        let res = await API.graphql({
            query: getBookmark,
            variables: {
                id: bookmarkId
            },
        });
        return res.data.getBookmark;
    } catch (err) {
        console.log('getBookmarkAPI error >>>', err)
        return {};
    }
}